import { IComputedParameterDef } from '@/pages/Parameters/parameters.types'
import parameterIdToSourceIdMap from '@/pages/Parameters/parameters.map'
import { IEquipment, IEquipmentEvent } from '@/pages/Equipment/equipment.types'
import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types'
import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types'
import liftWinchPowerComputeFunctions from './liftWinchPower.computeFunctions'
import { MutableRefObject } from 'react'

const baseSourceIds = ['MDRunSgl', 'MDReadySgl', 'ONKMCSgl', 'carSpeedWhole', 'carSpeedFractional', 'K7RelayState']

const computed: IComputedParameterDef[] = [
  {
    id: 'computed:isCarInMotion',
    name: 'Кабина находится в движении',
    dependsOn: [
      parameterIdToSourceIdMap['MDRunSgl'],
      parameterIdToSourceIdMap['carSpeedWhole'],
      parameterIdToSourceIdMap['carSpeedFractional'],
    ],
    compute: ({ get }) =>
      liftWinchPowerComputeFunctions.computeIsCarInMotion(
        get(parameterIdToSourceIdMap['MDRunSgl']),
        get(parameterIdToSourceIdMap['carSpeedWhole']),
        get(parameterIdToSourceIdMap['carSpeedFractional'])
      ),
  },
  {
    id: 'computed:MDReadySglANDONKMCSgl',
    name: 'Активно когда сработали MDReadySgl и ONKMCSgl',
    dependsOn: [parameterIdToSourceIdMap['MDReadySgl'], parameterIdToSourceIdMap['ONKMCSgl']],
    compute: ({ get }) => get(parameterIdToSourceIdMap['MDReadySgl']) && get(parameterIdToSourceIdMap['ONKMCSgl']),
  },
  {
    id: 'computed:isKMF12Closed',
    name: 'Выключатель 1 - 2 (KMF) замкнут',
    dependsOn: [
      parameterIdToSourceIdMap['MDReadySgl'],
      parameterIdToSourceIdMap['MDRunSgl'],
      parameterIdToSourceIdMap['K7RelayState'],
    ],
    compute: ({ get }) =>
      liftWinchPowerComputeFunctions.computedIsKMF12Closed(
        get(parameterIdToSourceIdMap['MDReadySgl']),
        get(parameterIdToSourceIdMap['MDRunSgl']),
        get(parameterIdToSourceIdMap['K7RelayState'])
      ),
  },
  {
    id: 'computed:isKMF34Closed',
    name: 'Выключатель 3 - 4 (KMF) замкнут',
    dependsOn: [
      parameterIdToSourceIdMap['MDReadySgl'],
      parameterIdToSourceIdMap['ONKMCSgl'],
      parameterIdToSourceIdMap['MDRunSgl'],
      parameterIdToSourceIdMap['K7RelayState'],
    ],
    compute: ({ get }) =>
      liftWinchPowerComputeFunctions.computedIsKMF34Closed(
        get(parameterIdToSourceIdMap['MDReadySgl']),
        get(parameterIdToSourceIdMap['ONKMCSgl']),
        get(parameterIdToSourceIdMap['MDRunSgl']),
        get(parameterIdToSourceIdMap['K7RelayState'])
      ),
  },

  {
    id: 'computed:isKMСContactorBreak',
    name: 'Контактор КМС неисправен',
    dependsOn: [parameterIdToSourceIdMap['MDReadySgl'], parameterIdToSourceIdMap['ONKMCSgl']],
    compute: ({ get }) =>
      Number(get(parameterIdToSourceIdMap['MDReadySgl']) === 0 && get(parameterIdToSourceIdMap['ONKMCSgl']) === 1),
  },
]

const generateParameters = (
  equipment: IEquipment,
  events: MutableRefObject<IEquipmentEvent[]>
): IComputedParameterDef[] => {
  if (!events.current) return []
  return [
    ...liftWinchPowerConfig.computed,
    {
      id: 'computed:isKMFContactorWelded',
      name: 'Контактор КМF заварен',
      dependsOn: [],
      compute: () => Number(liftWinchPowerComputeFunctions.isKMFContactorWelded(equipment, events.current)),
    },
    {
      id: 'computed:isKMFContactorBreak',
      name: 'Контактор КМF неисправен',
      dependsOn: [
        parameterIdToSourceIdMap['MDRunSgl'],
        parameterIdToSourceIdMap['MDReadySgl'],
        parameterIdToSourceIdMap['ONKMCSgl'],
        parameterIdToSourceIdMap['K7RelayState'],
      ],
      compute: ({ get }) =>
        Number(
          liftWinchPowerComputeFunctions.isKMFContactorBreak(
            get(parameterIdToSourceIdMap['MDRunSgl']),
            get(parameterIdToSourceIdMap['MDReadySgl']),
            get(parameterIdToSourceIdMap['ONKMCSgl']),
            get(parameterIdToSourceIdMap['K7RelayState'])
          ) && !liftWinchPowerComputeFunctions.isKMFContactorWelded(equipment, events.current)
        ),
    },
  ]
}

const generateWidgetConfig = (svgSettings: ISVGSettings): ISVGChartWidget => {
  return {
    id: 2,
    type: 'svg',
    dashboardId: 2,
    createdAt: '',
    updatedAt: '',
    configuration: {
      settings: svgSettings,
      topLeftX: 0,
      topLeftY: 0,
      width: '100%' as any,
      height: '100%' as any,
    },
  }
}

const liftWinchPowerConfig = { computed, baseSourceIds, generateParameters, generateWidgetConfig }
export default liftWinchPowerConfig
